export const valueToCurrency = value => {
  if (!value) {
    return 0;
  }
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const currencyToNumber = val => {
  if (!val) {
    return 0;
  }
  return parseFloat(val.toString().replace(/,/g, ""), 10);
};

export const addKoboToValue = num => {
  if (!num) {
    return "0.00";
  }

  if (num < 0) {
    return "0.00";
  }

  return num
    .toFixed(2)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const payrollValueToCurrency = num => {
  if (!num) {
    return "0.00";
  }

  if (num < 0) {
    return "0.00";
  }
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
